
export enum ListingTier {
  FREE = 'FREE',
  FEATURED = 'FEATURED',
  PREMIUM = 'PREMIUM',
  EXCLUSIVE = 'EXCLUSIVE'
}

export enum Category {
  TOWN_PLANNING = 'Town Planning',
  BUILDING_SURVEYING = 'Building Surveying',
  BUILDER = 'Builder',
  LAND_SURVEYING = 'Land Surveying',
  DRAFTING_DESIGN = 'Drafting / Design',
  ARCHITECTURE = 'Architects',
  LANDSCAPE_ARCHITECTS = 'Landscape Architects',
  ENGINEERING_CIVIL = 'Civil / Structural Engineers',
  ENGINEERING_TRAFFIC = 'Traffic Engineers',
  ENGINEERING_STORMWATER = 'Stormwater Engineers',
  ENGINEERING_ACOUSTIC = 'Acoustic Engineers',
  SOIL_GEOTECH = 'Soil Testers / Geotechnical',
  ARBORISTS = 'Arborists',
  HERITAGE_ADVISORS = 'Heritage Advisors',
  CULTURAL_HERITAGE = 'Cultural Heritage Consultants',
  ENERGY_RATERS = 'Energy Raters',
  ENVIRONMENTALLY_SUSTAINABLE_DESIGN = 'ESD Consultants',
  WASTE_MANAGEMENT = 'Waste Management',
  BUSHFIRE = 'Bushfire (BAL) Assessors',
  SDA_ASSESSORS = 'SDA Assessors',
  ENVIRONMENTAL = 'Environmental Services'
}

export interface Review {
  id: string;
  author: string;
  rating: number;
  comment: string;
  date: string;
}

export interface GalleryImage {
  url: string;
  description: string;
}

export interface Professional {
  id: string;
  businessName: string;
  category: Category;
  tier: ListingTier;
  rating: number;
  reviewCount: number;
  abn?: string;
  location: {
    state: string;
    suburb: string;
    council?: string;
    address?: string;
    lat: number;
    lng: number;
  };
  contact: {
    phone: string;
    email: string;
    website?: string;
  };
  description: string;
  tags: string[];
  imageUrl?: string;
  logoUrl?: string;
  gallery?: GalleryImage[];
  isVerified?: boolean;
  createdAt: string; // ISO date string
  reviews?: Review[];
}

export interface AIRecommendation {
  summary: string;
  projectScope: string;
  coreRoles: Category[];
  additionalRoles: Category[];
  potentialOverlays: string[];
  requiredReports: string[];
  estimatedFeeRange: string;
}

export interface WizardFormData {
  address: string;
  projectType: string;
  budget: string;
  description: string;
}
